import { DateRangeElement } from "@portal/BaseComponents/Filters/Elements/DateRange/DateRangeElement";
import { getDateRangeText } from "@portal/BaseComponents/Filters/Elements/DateRange/utils";
import { FilterDropdownDown } from "@portal/BaseComponents/Filters/FilterDropdown/FilterDropdownDown";
import { useFormats } from "@portal/hooks/use-formats";
import useOpen from "@portal/hooks/useOpen";
import { paymentFiltersAtom } from "@portal/store/Filters/payments/payments-filter";
import { resetPage, tableAtom } from "@portal/store/table/table";
import produce from "immer";
import { useAtom, useSetAtom } from "jotai";

function PaymentDateFilter() {
  const { onClose, open, toggleOpen, handleOpenChange } = useOpen({
    open: false,
  });
  const setTable = useSetAtom(tableAtom);
  const [paymentFilters, setPaymentsFilters] = useAtom(paymentFiltersAtom);
  const { dateformat } = useFormats();
  function handleHideReset() {
    return Object.values({
      from: paymentFilters.filterValues.from_date,
      to: paymentFilters.filterValues.to_date,
      type: paymentFilters.filterValues.date_range,
    }).includes(undefined);
  }
  const Content = (
    <DateRangeElement
      value={{
        from: paymentFilters.filterValues.from_date,
        to: paymentFilters.filterValues.to_date,
        type: paymentFilters.filterValues.date_range,
      }}
      onSubmit={(value) => {
        setPaymentsFilters((filter) => {
          return produce(filter, (draft) => {
            draft.filterValues.from_date = value.from;
            draft.filterValues.to_date = value.to;
            draft.filterValues.date_range = value.type;
            return draft;
          });
        });
        onClose();
        setTable(resetPage);
      }}
      onCancel={onClose}
    />
  );

  function handleReset() {
    setPaymentsFilters((filter) => {
      return produce(filter, (draft) => {
        draft.filterValues.from_date = undefined;
        draft.filterValues.to_date = undefined;
        draft.filterValues.date_range = undefined;
        return draft;
      });
    });
  }
  const hideReset = handleHideReset();
  return (
    <FilterDropdownDown
      filterBlockProps={{
        isDefault: true,
        toggleOpen,
        open,
        title: "Payment Date",
        filterValues: getDateRangeText(
          {
            from: paymentFilters.filterValues.from_date,
            to: paymentFilters.filterValues.to_date,
            type: paymentFilters.filterValues.date_range,
          },
          dateformat
        ),
        onReset: handleReset,
        hideReset,
      }}
      filterComponent={Content}
      filterTitle={"Payment Date"}
      onopenChange={handleOpenChange}
    />
  );
}

export { PaymentDateFilter };
